import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.VideoPlayerRoot),
  () => import('./VideoPlayer'),
  (VideoPlayer) => {
    ComponentUtil.binder(Hooks.VideoPlayerRoot, VideoPlayer);
  },
);
